import React from 'react';
import Icon from '../../../components/AppIcon';

const EmotionalStateSelector = ({ selectedStates, onStateToggle }) => {
  const emotionalStates = [
    { id: 'relaxed', label: 'Relaxed', icon: 'Wind' },
    { id: 'stressed', label: 'Stressed', icon: 'CloudRain' },
    { id: 'happy', label: 'Happy', icon: 'Sun' },
    { id: 'tired', label: 'Tired', icon: 'Moon' },
    { id: 'excited', label: 'Excited', icon: 'Zap' },
    { id: 'anxious', label: 'Anxious', icon: 'AlertCircle' },
    { id: 'confident', label: 'Confident', icon: 'Award' },
    { id: 'vulnerable', label: 'Vulnerable', icon: 'Heart' }
  ];

  const isSelected = (stateId) => selectedStates?.includes(stateId);

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-heading font-semibold text-foreground">
        Emotional State
      </h3>
      <p className="text-sm text-muted-foreground">
        How are you feeling emotionally right now?
      </p>
      <div className="flex flex-wrap gap-2">
        {emotionalStates?.map((state) => (
          <button
            key={state?.id}
            onClick={() => onStateToggle(state?.id)}
            className={`
              flex items-center space-x-2 px-4 py-2 rounded-md border
              transition-therapeutic
              ${isSelected(state?.id)
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-border bg-card text-foreground hover:border-primary/30'
              }
            `}
          >
            <Icon 
              name={state?.icon} 
              size={18} 
              color={isSelected(state?.id) ? 'var(--color-primary-foreground)' : 'currentColor'}
            />
            <span className="text-sm font-medium">
              {state?.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmotionalStateSelector;